import { alpha, darken, lighten } from '@mui/material/styles';
import color from 'styles/color';

function createGradient(color1: string, color2: string) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: color.blue03,
  light: color.blue04,
  main: color.blue05,
  dark: color.blue06,
  darker: color.blue07,
  contrastText: '#fff',
};
const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
};
const INFO = {
  lighter: lighten(GREY[600], 0.075),
  light: lighten(GREY[600], 0.05),
  main: GREY[600],
  dark: darken(GREY[600], 0.05),
  darker: darken(GREY[600], 0.075),
  contrastText: '#fff',
};
const SUCCESS = {
  lighter: lighten('#4FA85E', 0.075),
  light: lighten('#4FA85E', 0.05),
  main: '#4FA85E',
  dark: darken('#4FA85E', 0.05),
  darker: darken('#4FA85E', 0.075),
  contrastText: '#fff',
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: alpha('#919EAB', 0.24),
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: {
    paper: '#fff',
    default: '#fff',
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha('#919EAB', 0.08),
    selected: alpha('#919EAB', 0.16),
    disabled: alpha('#919EAB', 0.8),
    disabledBackground: alpha('#919EAB', 0.24),
    focus: alpha('#919EAB', 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
  contents: {
    background: {
      main: '#F1EFE6',
    },
  },
};

export default palette;
